import { ITranslate } from "@/interfaces/ITranslate";

export const reportSectionTranslate: ITranslate = {
  title: "el título",
};
